const applyFilters = (filters, html) => {
  let filteredHtml = html;

  filters.forEach((filter) => {
    filteredHtml = filter(filteredHtml);
  });

  return filteredHtml;
};

export default applyFilters;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/helpers/apply.js
 **/